import React from "react";
import { useTranslation } from "react-i18next";
import images from "src/assets/image";

/**
 * Auth split-screen — SIFIRDAN. Sol: marka paneli (gradient), Sağ: form paneli.
 * Login / ForgetPassword / ResetPassword ortak kullanır.
 */
const Layout = ({
  children,
  title,
  subtitle,
}: {
  children: any;
  title?: string;
  subtitle?: string;
}) => {
  const { t } = useTranslation();
  const bullets = [
    t("Auth.Bullet1", "Filo, sözleşme ve müşteri yönetimi tek yerde"),
    t("Auth.Bullet2", "Çoklu dil, çoklu para birimi ve paket yönetimi"),
    t("Auth.Bullet3", "Web sitesi, e-posta ve storefront entegrasyonu"),
  ];
  return (
    <div className="auth2">
      <div className="auth2__brand">
        <div className="auth2__wordmark">Rentificial</div>
        <div>
          <h1 className="auth2__headline">
            {t("Auth.BrandHeadline", "Kiralama işini tek panelden yönet.")}
          </h1>
          <ul className="auth2__bullets">
            {bullets.map((b, i) => (
              <li key={i}>
                <span className="chk">
                  <i className="mdi mdi-check" />
                </span>
                {b}
              </li>
            ))}
          </ul>
        </div>
        <div className="auth2__foot">© {t("Auth.Copyright", "Rentificial — Yönetim Paneli")}</div>
      </div>

      <div className="auth2__form">
        <div className="auth2__card">
          <img className="auth2__logo" src={images.logo} alt="Rentificial" />
          {title && <h2 className="auth2__title">{title}</h2>}
          {subtitle && <p className="auth2__sub">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};
export default Layout;
